import { defineComponent } from "vue";

/**
 * 渲染 `Appointment` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Appointment = defineComponent({
	name: "Appointment",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M863 160H161c-35.35 0-64 28.65-64 64v672c0 35.35 28.65 64 64 64h702c35.35 0 64-28.65 64-64V224c0-35.35-28.65-64-64-64z m0 704c0 17.67-14.33 32-32 32H193c-17.67 0-32-14.33-32-32V256c0-17.67 14.33-32 32-32h638c17.67 0 32 14.33 32 32v608z"></path>
				<path d="M709.64 304c-17.67 0-32-14.33-32-32V96c0-17.67 14.33-32 32-32s32 14.33 32 32v176c0 17.67-14.33 32-32 32zM314.36 304c-17.67 0-32-14.33-32-32V96c0-17.67 14.33-32 32-32s32 14.33 32 32v176c0 17.67-14.32 32-32 32zM656.69 528H544V415.31c0-17.67-14.33-32-32-32s-32 14.33-32 32V528H367.31c-17.67 0-32 14.33-32 32s14.33 32 32 32H480v112.69c0 17.67 14.33 32 32 32s32-14.33 32-32V592h112.69c17.67 0 32-14.33 32-32s-14.32-32-32-32z"></path>
			</svg>
		);
	},
});

export default Appointment;
